import { SequenceStep, enumActions } from "../Guide";

import { itx } from "../../translationItx/itx";
import Floor from "../../models/Floor";
import { ToDoItem } from "../ToDoItem";
import { sleep } from "../../models/utils";

// ContextMenuLables.addFloors
function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  return [
    {
      action: enumActions.focus,
      id: () => {
        return `tv-${state.floors.id}`;
      }, // TreeNode without # or . prefix  #  is assumed
    },
    {
      action: enumActions.click,
      id: () => {
        return [
          `tv-${state.floors.id}`, // TreeNode
          `ContextMenuLables_addFloors`, // Menu inside TreeNode
        ];
      },
    },
    {
      action: enumActions.wait, // wait until dialog is open
    },
    // {
    //   action: enumActions.explain,
    //   id: `FloorDialog_name`,
    //   text: itx("onBoardingSequences.tagNameNewFloor"),
    // },
    {
      action: enumActions.call,
      subSequence: () => {
        // calc here the name and tag
        let choosenName = "";
        let allPossibleNameTag = [
          itx("step1.groundFloor", "Erdgeschoss"),
          itx("step1.attic", "Dachgeschoss"),
          itx("step1.cellar", "Keller"),
          itx("step1.loft", "Bühne"),
          itx("step1.floorX", "Etage x"),
        ];
        allPossibleNameTag.forEach((possibility) => {
          let allreadyInProject = false;
          state.floors.forEach((floor) => {
            if (floor.name == possibility) allreadyInProject = true;
          });
          if (!allreadyInProject && choosenName == "") {
            choosenName = possibility;
          }
        });

        return [
          {
            id: `FloorDialog_name`,
            action: enumActions.type,
            text: choosenName, // itx("onBoardingSequences.nameNewRoom", "Ein Neuer Raum"),
          },
        ];
      },
    },

    {
      id: `BaseDialog_ok`,
      action: enumActions.click,
    },
    {
      action: enumActions.wait,
    },
    // Just for debugging: MWE
    // {
    //   action: enumActions.function,
    //   func: async () => {
    //     state.selectionManager.selectedObject = state.guideMode.lastCreatedObject;
    //     await sleep(200);
    //   },
    // },
    // {
    //   action: enumActions.explain,
    //   id: () => {
    //     return `tv-${state.guideMode.lastCreatedObject?.id}`;
    //   },

    //   text: itx("onBoardingSequences.floorCreated"),
    // },
  ];
}

export default sequence;
